// Loaded only for a server-recognized member. Close the retail popup through
// its own control so Klaviyo also releases focus and its background overlay.
(() => {
  const dismissRetailSignup = () => {
    document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]').forEach(dialog => {
      if (!dialog.querySelector('[class*="klaviyo-form"]')) return;
      const close = dialog.querySelector('button[aria-label="Close dialog"]');
      if (close && !close.disabled) close.click();
    });
  };
  const observer = new MutationObserver(dismissRetailSignup);
  observer.observe(document.documentElement, {childList: true, subtree: true});
  window.addEventListener('klaviyoForms', dismissRetailSignup);
  dismissRetailSignup();
})();
